// extracted by mini-css-extract-plugin
export default {"container":"CopyVoucher_container__C9fvg","copy":"CopyVoucher_copy__1IGVF"};